import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  eyebrow?: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({
  title,
  eyebrow,
  description,
  linkTo,
  linkLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1 rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-flashlight-fill text-xs" aria-hidden="true"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">{title}</h2>
        {description && <p className="mt-2 max-w-2xl text-sm text-foreground-500">{description}</p>}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 cursor-pointer"
        >
          {linkLabel}
          <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}